import { Button, Typography } from 'antd';
import React, { ReactElement } from 'react';
import Layout from './Layout';

export default function BrokersExport(): ReactElement {
    return (
        <Layout section='brokers-export'>
            <Typography.Title level={2}>Brokers Export</Typography.Title>
            <Button
                href={`${process.env.API_HOST}/brokers/download-report`}
                target='_blank'
                type='primary'
            >Download</Button>
        </Layout>
    );
}
